import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useNotificationStore } from './notificationStore'

export const useAppStore = defineStore('app', () => {
  const notificationStore  = useNotificationStore()
  const isPageLoading =    ref(false)
  const isNewTransfereeModalVisible  = ref(false)

  function setIsPageLoading(flag) {
    isPageLoading.value = flag
  }

  function toggleNewTransfereeModal() {
    isNewTransfereeModalVisible.value = !isNewTransfereeModalVisible.value
  }

  // store
  function notify(params){
    return notificationStore.notify(params)
  }
  function setMessages(params){
    return notificationStore.setMessages(params)
  }

  // const railsConfig = ref({})

  const viteConfig = {
    appVer:      import.meta.env.VITE_APPVER, // APPVER is set in package.json file
    currentEnv:  import.meta.env.MODE,
  }

  return {
    isNewTransfereeModalVisible,
    isPageLoading,
    setIsPageLoading,
    // notificationStore passthrough methods
    notify,
    setMessages,
    toggleNewTransfereeModal,
    // other
    viteConfig,
  }
}, 
{
  persist: { paths: ['isPageLoading'] }
})
